import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationMessageToField = ({
  validationErrors
}) => {
  switch (true) {
    case validationErrors.to.empty:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.sendInvoiceModal.fields.to.validationMessage.missingContacts"
      });
    case validationErrors.to.invalidEmails:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.sendInvoiceModal.fields.to.validationMessage.email"
      });
    case validationErrors.tooManyContacts:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.sendInvoiceModal.fields.all.validationMessage.max"
      });
    default:
      return null;
  }
};
export default ValidationMessageToField;